import type { StatefulTableOptions } from '@/utils/table/hooks/useGetStatelessTableProps';
import { useGetStatelessTableProps } from '@/utils/table/hooks/useGetStatelessTableProps';
import type {
  FieldConfig,
  TableFields,
  TablePropsWithActions,
  TableRecord,
} from '@/utils/table/types';

/**
 * Creates table props for relationship data sources using useGetStatelessTableProps.
 */
export const useRelationshipTableProps = <TRow extends TableRecord>(
  data: TRow[] | undefined,
  fields: TableFields<TRow>,
  entityLabel: string,
  options: StatefulTableOptions<TRow>
): TablePropsWithActions<TRow> => {
  return useGetStatelessTableProps<TRow>({
    data,
    fields,
    entityLabel,
    customAttributeFormIds: [],
    enableFiltering: false,
    ...options,
  });
};

/**
 * Creates a simple field config for a string field.
 */
export const simpleField = <T extends TableRecord>(
  header: string
): FieldConfig<T> => ({
  header,
});
